define('bindingHandlers/integerPicker',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'bindingHandlers/util/spinnerUtil',
    'extensions/knockoutExtenders/numeric',
    'bindingHandlers/include'
], function (ko, _, moment, spinnerUtil) {
    "use strict";

    /**
     *  integer Picker
     *
     * @description: creates a straight up integer incrementer and decrementer
     *
     * REQUIRES:
     *
     * value (observable) - just an integer
     *
     * You could do more with this. I am just trying to keep it really basic for the time being.
     *
     */

    ko.bindingHandlers.integerPicker = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var self = this;
            var bindingData = valueAccessor();
            var item_template = bindingData.template ? bindingData.template : 'templates/widgets/integerPicker_days';
            var templateData = {};
            var tempHolder = {};

            tempHolder.item = bindingData.value.extend({numeric: {precision: 0, min: 0, max: 999999}});
            templateData.item = tempHolder.item;

            // merge the templateData set above with the click handlers from the spinner utility
            _.merge(templateData, spinnerUtil.handleClickDirections(tempHolder));

            var includeValueAccessor = ko.observable({
                name: item_template,
                data: templateData
            });

            ko.bindingHandlers.include.init.call (self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
            ko.bindingHandlers.include.update.call(self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
        }
    };
});

